<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
        <div class="approvalBox">
          <!-- <form> -->
      <el-tabs v-model="billTabName" @tab-click="billTabClick" type="card" style="margin-top:20px">
        <el-tab-pane label="类型" name="rechargeBill">
            <div class="form-line" v-for="item in innerList">
              <div class="textBox" style="margin-right: 20px;">
                <b class="red">*</b>
                <span class="line-text">{{item.typeText}}：</span>
              </div>
              <el-switch
                v-model="item.accessible"
                @change="confirm(item)"
                active-text="是"
                inactive-text="否">
              </el-switch>
              <div v-if="item.type != 2 && item.accessible==true" class="textBox" style="margin-right: 20px;">
                <b class="red">*</b>
                <span class="line-text">外场是否收费：</span>
              </div>
              <el-switch
                v-if="item.type != 2 && item.accessible==true"
                v-model="item.outfieldCharge"
                @change="confirm(item)"
                active-text="是"
                inactive-text="否">
              </el-switch>
            </div>
        </el-tab-pane>
        <el-tab-pane label="车牌号">
            <div class="search-line">
              <div style="display: flex;justify-content: space-between">
                <button-add @click="toAddPage" style="margin-right:20px"></button-add>
                <button-delete @deleteSelection="deleteSelection"/>
                <button-upload :cathUrl="uploadUrl" @getpage="getInnerConfigPage" :onSuccess="onUploadSuccess" value="导入"/>
              </div>
            <div style="display: flex;justify-content: space-between">
              <input-search placeholder="车牌号" @search="searchKey" style="margin-right:10px"/>
              <button-export :href="exportUrl" :beforeDownload="beforeDownload" download="download.xls" value="导出"/>
            </div>
            </div>
            <table-main :tableHead="tableHead" :tableData="tableData" @changeSelection="changeSelection" :total="total" :pageNum="requestData.pageNum" :pageSize="requestData.pageSize" @changePagination="changePagination" :operationArr="rechargeOperationArr" @deleteLine="deleteLine" />
        </el-tab-pane>
      </el-tabs>
            <!-- <div class="form-btn-box">
              <button-confirm @confirm="confirm" />
              <button-cancel @cancel="cancel" />
            </div> -->

          <!-- </form> -->
        </div>
        <el-dialog
          title="添加车牌号"
          :visible.sync="dialogVisible"
          width="30%"
          :before-close="handleClose">
        <el-input v-model="formData.carNumber" size="small" style="width: 280px" />
          <span slot="footer" class="dialog-footer">
            <el-button size="small" @click="cancel">取 消</el-button>
            <el-button type="primary" size="small" @click="confirm2">确 认</el-button>
          </span>
        </el-dialog>
  </div>
</template>

<script>
import Breadcrumb from "../../../../components/Breadcrumb/Breadcrumb";
import ButtonAdd from "../../../../components/common/buttons/button-add";
import InputSearch from "../../../../components/Input/InputSearch";
import TableMain from "../../../../components/Table/TableMain";
import ButtonExport from "../../../../components/common/buttons/button-export";
import ButtonUpload from "../../../../components/common/buttons/button-upload";
import { api } from "../../../api/ParkingService";
import { errorHandler } from "../../../../utils/errorHandler";
import { nAlert, nSuccess } from "../../../../utils/notice";
import { bus } from "../../../../utils/bus";
import ButtonCancel from "../../../../components/Button/ButtonCancel";
import ButtonConfirm from "../../../../components/Button/ButtonConfirm";
import ButtonDelete from "../../../../components/Button/ButtonDelete";

export default {
  components: {
    ButtonConfirm,
    ButtonCancel,
    TableMain,
    InputSearch,
    ButtonAdd,
    Breadcrumb,
    ButtonExport,
    ButtonUpload,
    ButtonDelete
  },
  name: "inner-configuration",
  data() {
    return {
      breadcrumb: [
        {
          value: "智慧停车",
          name: "parking-device-management"
        },
        {
          value: "场中场配置"
        }
      ],
      configData: {},
      istempCarIn: false,
      carWhiteOtherIsCasual: false,
      permissionCodes: "",
      requestData: {
        pageNum: 1,
        pageSize: 10,
        searchKey: ""
      },
      innerList: [],
      billTabName: "rechargeBill",
      tableHead: [
        {
          prop: "carNumber",
          label: "车牌号"
        }
      ],
      tableData: [],
      total: 0,
      rechargeOperationArr: ["delete"],
      uploadUrl: "",
      exportUrl: "",
      dialogVisible: false,
      formData: {},
      selectionArr: []
    };
  },
  created() {
    this.getInnerConfigPage();
    this.permissionCodes = bus.global.permissionCodes;
    this.uploadUrl = api.importInnerCarNumber;
    console.log(this.uploadUrl);
  },
  methods: {
    beforeDownload() {
      this.exportUrl = `${api.exportInnerCarNumber}?yq-app-code=${bus.global.yqCode}&kj-type=gy&token=${bus.global.token}&searchKey=${this.requestData.searchKey}`;
    },
    getInnerConfigPage() {
      let url = "";
      if (this.billTabName === "rechargeBill") {
        url = api.getInnerConfigPage;
      } else {
        url = api.getInnerCarNumberPage;
      }
      this.$axios
        .post(url, this.requestData)
        .then(res => {
          if (res.data.retCode === 1) {
            let data = res.data.data.list;
            console.log(data);
            data.map(v => {
              if (v.type == "1") {
                v.typeText = "包月车";
              } else if (v.type == "2") {
                v.typeText = "临停车";
              } else if (v.type == "4") {
                v.typeText = "白名单";
              }
              v.code = v.carNumber;
            });
            this.innerList = data;
            this.tableData = data;
            this.total = res.data.data.total;
          }
        })
        .catch(errorHandler("查询失败"));
    },

    //修改
    confirm(data) {
      this.$confirm(`确认修改场中场的${data.typeText}配置？`, "提示")
        .then(() => {
          for (let i in data) {
            if (data[i] === "--") {
              data[i] = "";
            }
          }
          let data1 = {};
          data1.accessible = data.accessible;
          data1.type = data.type;
          data1.outfieldCharge = data.outfieldCharge
          this.$axios
            .post(api.updateInnerConfig, data1)
            .then(res => {
              nSuccess("修改成功");
              this.getInnerConfigPage();
            })
            .catch(errorHandler("修改失败"));
        })
        .catch(() => {
          this.getInnerConfigPage();
        });
    },
    billTabClick() {
      this.requestData.pageNum = 1;
      this.requestData.pageSize = 10;
      this.getInnerConfigPage();
    },
    changePagination(data) {
      this.requestData.pageNum = data[0];
      this.requestData.pageSize = data[1];
      this.getInnerConfigPage();
    },
    onUploadSuccess(data) {
      if (data.retCode == 1) {
        nSuccess("导入成功");
        this.pageSize = 10;
        this.pageNum = 1;
        this.getInnerConfigPage();
      } else {
        errorHandler("导入失败")(data);
      }
    },
    searchKey(v) {
      this.requestData.pageNum = 1;
      this.requestData.searchKey = v;
      this.getInnerConfigPage();
    },
    toAddPage() {
      console.log(123);
      this.dialogVisible = true;
    },
    handleClose() {
      this.dialogVisible = false;
    },
    cancel() {
      this.dialogVisible = false;
    },
    confirm2() {
      this.$axios
        .post(api.addInnerCarNumber, this.formData)
        .then(res => {
          if (res.data.retCode === 1) {
            nSuccess("添加成功");
            this.formData = {};
            this.getInnerConfigPage();
          }
        })
        .catch(errorHandler("添加失败"));
      this.dialogVisible = false;
    },
    changeSelection(codeArr) {
      this.selectionArr = codeArr;
    },
    deleteSelection() {
      if (this.selectionArr.length === 0) {
        nAlert("请先选择需要删除的车牌号");
        return false;
      } else {
        this.$confirm("是否确认删除该车牌号？", "提示")
          .then(() => {
            this.deleteLine(this.selectionArr);
          })
          .catch(() => {
            console.log("取消删除");
          });
      }
    },
    deleteLine(code) {
      this.$axios
        .post(api.deleteInnerCarNumber, code)
        .then(res => {
          if (res.data.retCode === 1) {
            nSuccess("删除成功");
            this.selectionArr = [];
            this.getInnerConfigPage();
          }
        })
        .catch(errorHandler("删除失败"));
    }
  }
};
</script>

<style scoped>
.search-line {
  display: flex;
  justify-content: space-between;
  margin: 20px 0;
}
form {
  /* width: 90%; */
  /* margin: 0 auto; */
  text-align: center;
}
.red {
  color: #ff0000;
}
.form-line {
  margin: 20px 0;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.form-line > span {
  font-size: 12px;
  color: #97a8be;
}
.line-text {
  color: #48576a;
  font-size: 14px;
  margin-right: 10px;
}
.textBox {
  display: inline-block;
  width: 120px;
  text-align: right;
}
.textBox2 {
  display: inline-block;
  width: 320px;
  text-align: left;
}
.form-btn-box {
  width: 530px;
  padding: 0 124px;
  margin-top: 40px;
  display: flex;
  justify-content: space-between;
}
</style>
<style lang="less">
.approval-manage {
  .approvalBox {
    margin-top: 20px;
  }
  .el-tabs--top.el-tabs--card .el-tabs__item:last-child {
    width: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/ParkingService/ParkingOtherConfig/InnerConfiguration/InnerConfiguration.vue